import * as Yup from "yup";

export const positionValidation = Yup.object().shape({
  name: Yup.string().matches(/^[^–—+*/=]*$/, 'The title cannot include –, —, +, *, /, or =').required("Required"),
  experience: Yup.string().required("Required"),
  positionId: Yup.string().required("Required"),
});
